<template>
    <div class="row">
        <div class="col-12 my-2">
            <div class="card-header-actions">

              <div class="col-lg-6 col-md-8 col-12 card-header-filter-box">
                <div class="row align-items-end">
                  <div class="col-12 col-sm-8 card-header-search-box">
                    <div class="input-group">
                        <input class="form-control search-input" type="text" :placeholder="$t('main.search')" v-model="filter.search"
                               @keypress.enter="initList">
                        <div class="input-group-append">
                            <button class="all-btn search-btn" @click="initList">
                                <i class="fa fa-search"></i>
                            </button>
                        </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-6 col-md-4 col-12 justify-content-md-end mt-md-0 mt-2 card-header-btns-box">
                <button class="all-btn add-btn m-0" v-if="hasPermission('SETTINGS_BUILDING_STOREYS_ADD')" @click="showOtherConfigAdd(null)">{{$t("action.add")}}</button>
              </div>

            </div>
        </div>
        <div class="col-12">
            <div class="table-wrapper">
              <table class="table table-hover">
                  <thead>
                  <tr>
                      <th>ID</th>
                      <th>Яратилган сана</th>
                      <th>Яратган фойдаланувчи</th>
                      <th>Қаватлилиги</th>
                      <th>Қавати</th>
                      <th>Қиймати</th>
                  </tr>
                  </thead>
                  <tbody v-for="result in results.data" :key="result.id">
                  <tr>
                      <td>{{result.id}}</td>
                      <td>{{new Date(result.createdDate) | dateFormat('DD.MM.YYYY HH:mm:ss')}}</td>
                      <td>{{result.createdBy.name}}</td>
                      <td>{{result.data.storeys}} қаватли</td>
                      <td>{{result.data.floor}} - қават</td>
                      <td>{{result.data.coeficient}} %</td>
                  </tr>
                  </tbody>
              </table>
            </div>
            <div class="text-center">
                <div class="loader mt-5 mb-5" v-if="loading"></div>
                <span class="no-data mt-5 mb-5" v-if="!loading && results && results.data && results.data.length===0">{{$t("messages.list.empty")}}</span>
            </div>
            <div class="row" v-if="!loading && results && results.total && results.total > 1 ">
                <div class="col-12 pt-3 pb-3">
                    <b-pagination :total-rows="results.total" v-model="filter.page.page" :per-page="filter.page.size"
                                  @change="onPageChange">
                    </b-pagination>
                </div>
            </div>
        </div>
        <building-storeys-add-view></building-storeys-add-view>
    </div>
</template>

<script>
    import bPagination from 'bootstrap-vue/es/components/pagination/pagination';
    import initFilterModel from '@/shared/filter';
    import BuildingStoreysAddView from '@/views/config/real-estate/BuildingStoreysAddView';

    export default {
        name: "BuildingStoreys",
        components: {
            'b-pagination': bPagination,
            BuildingStoreysAddView
        },
        data() {
            return {
                loading: false,
                filter: initFilterModel(),
                results: {},
                opened: [],
            }
        },
        methods: {
            initList() {
                this.loading = true;
                this.$http.post('dictionary/list/BUILDING_STOREYS', this.filter)
                    .then(res => {
                        this.results = res.data;
                        this.loading = false;
                    });
            },
            onPageChange(page) {
                this.filter.page.page = page;
                this.initList();
            },
            showOtherConfigAdd(data) {
                this.$eventBus.$emit('showBuildingStoreysAdd', data);
            },

            toggle(id) {
                const index = this.opened.indexOf(id);
                if (index > -1) {
                    this.opened.splice(index, 1)
                } else {
                    this.opened.push(id)
                }
            }
        },
        created() {
            this.initList();
            this.$eventBus.$on('buildingStoreysChanged', () => {
                this.initList();
            });
        }
    }
</script>

<style scoped>
    .opened {
        background-color: #3d8b40;
    }
</style>